<template>
  <main class="main colors">
    <div class="f container">
      <LazyUiBreadCrumbsV2
          :items="[
              {
                title: info.general?.team || '',
                link: localePath('/teams/' + getModifiedString(info.general?.team || ''))
              },
              {
                title: info.general?.nick_name || '',
                link: localePath('/pro-players/' + route.params.id)
              }
          ]"
      />
      <!--      <button-->
      <!--          :class="{compressed}"-->
      <!--          aria-label="compressed button"-->
      <!--          class="compress-btn ht hd"-->
      <!--          @click="toggleCompressed"-->
      <!--      >-->
      <!--        <svg>-->
      <!--          <use v-if="compressed" xlink:href="/icons/sprite.svg#grid-1"></use>-->
      <!--          <use v-else xlink:href="/icons/sprite.svg#grid-2"></use>-->
      <!--        </svg>-->
      <!--      </button>-->
    </div>
    <PagesProPlayer
        :info="info"
        :is-loading="status === 'pending'"
        :items="items"
        :pages-length="data?.pagination?.maxPages || 0"
        :total="data?.pagination?.total || 0"
    />
  </main>
</template>

<script lang="ts" setup>
import {EventBus} from '~/composables/bus';
import {AdvancedSearchBody, ProPlayerWithItems} from "~/graphql/generated/schema-types";


const {locale, t} = useI18n()
const route = useRoute()
const router = useRouter();
const localePath = useLocalePath()
// const {compressed, toggleCompressed} = useCompressed()

const page = computed(() => {
  return Number(route.query.page) || 1;
});

const getItems = async () => {
  try {
    const {
      data,
      errors
    } = await getProPlayer(
        route.params.id as string,
        locale.value,
        {
          page: page.value,
          limit: 10
        }
    )
    if (errors?.length) {
      throw new Error(errors[0].message)
    }

    return {
      items: (data.getProPlayer.items?.result || []) as AdvancedSearchBody[],
      info: data.getProPlayer,
      pagination: {
        maxPages: data.getProPlayer?.items?.max_pages || 0,
        total: data.getProPlayer?.items?.total_count || 0,
      },
    }
  } catch (e: any) {
    EventBus.$emit('notify', {
      success: false,
      msg: e.message || 'An error occurred'
    })

    console.log('pro-player page error', e.message)
    throw new Error(e.message || 'An error occurred')
    // return {
    //   items: [] as AdvancedSearchBody[],
    //   info: {} as ProPlayer,
    //   pagination: {
    //     maxPages: 0,
    //     total: 0,
    //   },
    // }
  }
}

const {data, error, status} = await useAsyncData('pro-player-items', getItems, {
  watch: [page],
})

if (error.value) {
  console.error('Error fetching pro-player items', error.value)
  throw createError({
    status: 404,
    statusText: 'Error fetching pro-player page error: ' + error.value.message
  })
}

const items = computed(() => (data.value?.items || []) as AdvancedSearchBody[])
const info = computed(() => data.value?.info || {} as ProPlayerWithItems)

watch(page, () => {
  if (process.client) {
    window.scrollTo(0, 0)
  }
})

const teams = {
  'Group 1': ['9 Pandas',
    'Complexity',
    '9z Team',
    '9INE Academy',
    'Wu-Tang',
    '9INE',
    'Monte',
    'Astralis',
    '3DMAX',
    'Paquetá Gaming',
    'FlyQuest',
    'Nakama',
    'RED Canids',
    'Talon Esports',
    'Sangal',
    'Los Grandes',
    'Anonymo',
    'UNGENTIUM',
    'Young Ninjas',
    'Entropiq',
    'Heroic',
    'SINNERS Esports',
    'Project G',
    'paiN Gaming',
    'JiJieHao',
    'PARIVISION',
    'Fire Flux Esports',
    '500 Rush',
    'ATOX Esports',
    'FLUFFY AIMERS',
    'BC.Game',
    'Johnny Speeds',
    'DRILLAS'],
  'Group 2': ['Ninjas in Pyjamas',
    'Eternal Fire',
    'Nigma Galaxy',
    'BOSS',
    'MOUZ',
    'TyLoo',
    'G2 Esports',
    'GamerLegion',
    'Arcadia',
    'Dynamo Eclot',
    'w7m esports',
    'M80',
    'Websterz',
    'Nouns Esports',
    'JANO Esports',
    'The Dice',
    'Rare Atom',
    'HAVU',
    '1WIN',
    'OG Esports',
    'Imperial Esports',
    'Natus Vincere Jr.',
    'Falcons Esports',
    '00Nation',
    'Nexus Gaming',
    'Content Creator',
    'ODDIK',
    'Permitta Esports',
    'iNation',
    'Monte Gen',
    'Onyx Ravens',
    'Reason Gaming'],
  'Group 3': ['Aurora',
    'FURIA',
    '500',
    'Mission Possible',
    'Zero Tenacity',
    'TropiCaos',
    'Natus Vincere',
    'Cloud9',
    'The Mongolz',
    'BESTIA',
    'Forward Gaming',
    'Wildcard Gaming',
    'KOI',
    'KRÜ Esports',
    'Fluxo',
    'Steel Helmet',
    'Case Esports',
    'Into The Breach',
    'Team oNe eSports',
    'ALTERNATE aTTaX EVO',
    'SAW',
    'Sharks Esports',
    'Copenhagen Wolves',
    'B8 Esports',
    'AGO',
    'Free Agent',
    'Party Astronauts',
    'Team Space',
    'Passion UA',
    'Elevate',
    'Vikings KR',
    'FAVBET'],
  'Group 4': ['ENCE',
    'ESC Gaming',
    'CEPTER',
    'FaZe Clan',
    'Fnatic',
    'Sashi',
    'Virtus.pro',
    'BIG',
    'Team Spirit Academy',
    'Pompa Team',
    'Flamengo Esports',
    'ALTERNATE aTTaX',
    'IKLA',
    'allStars Gaming',
    'Corinthians',
    'Team NKT',
    'Ambush Esports',
    'Mythic',
    'Encore Esports Club',
    'AMKAL',
    'Nemiga Gaming',
    'Alliance',
    'TSM',
    'forZe',
    'Legacy',
    'Unluko5',
    'The Witchers',
    'The Huns Esports',
    'Perseverance Gaming',
    'Revenant Esports',
    'brazylijski luz',
    'Alter Ego'],
  'Group 5': ['Rebels Gaming',
    'Team Spirit',
    'Hype Esports',
    'UNiTY ESPORTS',
    'Lynn Vision',
    'MIBR',
    'Team Liquid',
    'BetBoom Team',
    'undefined',
    'Team Vitality',
    'Twisted Minds',
    'Gaimin Gladiators',
    'Invictus Gaming',
    'O PLANO',
    'Trident Clan',
    'Enterprise Esports',
    'Team Sampi',
    'EYEBALLERS',
    'Nordavind',
    'GODSENT',
    'Finest',
    'Endpoint',
    'NRG',
    'ECSTATIC',
    'Metizport',
    'Meta Gaming',
    'CYBERSHOKE',
    'V1dar Gaming',
    'GUN5',
    'Pera Esports',
    'Viperio',
    'GR Gaming']
}
const titleAndDescByTeamGroup = computed(() => {
  let groupName = 'Group 1'
  const team = info.value.general?.team || ''

  for (const [key, value] of Object.entries(teams)) {
    if (value.includes(team)) {
      groupName = key
    }
  }
  groupName = getModifiedString(groupName).replaceAll('-', '_')
  return {
    title: t('heads.pro_player.title_' + groupName, {name: info.value.general?.nick_name}),
    desc: t('heads.pro_player.desc_' + groupName, {name: info.value.general?.nick_name})
  }
})

const title = computed(() => {
  return titleAndDescByTeamGroup.value.title || 'Title pro player page'
})

const description = computed(() => {
  return titleAndDescByTeamGroup.value.desc || 'Pro player page description'
})

const weaponIcon = computed(() => {
  return getImageFromProxy(info.value.general?.avatar || '', '300:300')
})

const {alternateLinks, canonical} = useAlternateLinks(`/pro-players/${route.params.id}`)

useHead({
  title: () => title.value,
  meta: [
    {
      name: "keywords",
      content: "steam, counter strike global offensive, csgo, cs2, skins, items",
    },
  ],
  link: () => alternateLinks.value
})

useSeoMeta({
  title: () => title.value,
  ogTitle: () => title.value,
  description: () => description.value,
  ogDescription: () => description.value,
  ogImage: () => weaponIcon.value,
  twitterCard: 'summary_large_image',
  twitterTitle: () => title.value,
  twitterDescription: () => description.value,
  twitterImage: () => weaponIcon.value,
  ogSiteName: 'CSMarketCap',
  ogUrl: () => canonical.value,
  ogType: 'website',
  ogLocale: () => locale.value
})

const {defineUseProduct} = useDefineProductWithAdvSearchItem()

useSchemaOrg([
  defineItemList({
    id: `itemlist-${title.value.replace(/\s+/g, '-').toLowerCase()}-pro-player-page-${locale.value}`, // Уникальный ID для списка
    name: title.value,
    description: description.value,
    image: () => weaponIcon.value,
    itemListElement: await Promise.all(items.value.map(async (weapon, index) => {
      const product = await defineUseProduct(weapon);

      return {
        '@type': 'ListItem',
        position: index + 1,
        item: product,
        id: product.id || `item-${index + 1}-${weapon?.market_hash_name}`,
      };
    })),
  }),
  defineBreadcrumb({
    itemListElement: [
      {name: () => t('main'), item: '/'},
      {name: title.value, item: localePath(`/pro-players/${route.params.id}`)},
    ],
  })
])
</script>

<style lang="scss" scoped>


.colors {
  padding: 15rem 2rem 4rem;
  margin: 0 auto;
  width: 100%;

  //.compress-btn {
  //  width: 40px;
  //  height: 40px;
  //  padding: 5px;
  //  border: 1px solid var(--gray);
  //
  //  &.compressed {
  //    padding: 8px;
  //  }
  //
  //  svg {
  //    width: 100%;
  //    height: 100%;
  //  }
  //}

  @media screen and (max-width: 1115px) {
    padding-top: 9rem;
  }
  @media screen and (max-width: 979px) {
    padding-top: 7rem;
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
